module.exports = __webpack_public_path__ + "media/wood_6.b58b085b.webm";